export default "__VITE_ASSET__$kAwh_Ka__"